// Central image + brand asset references for Vista Banquet Hall.
// ALL imagery below is real Vista Banquet Hall photography stored in /public/venue.
// b1–b4 = ballroom / hall wide shots, g1–g12 = event & décor gallery.
export const IMAGES = {
  // Ballroom / hall
  venueBallroom: "/venue/b1.webp",
  heroBallroom: "/venue/bro02.webp",
  ballroomGrand: "/venue/up_ballroom.jpeg",
  ballroomElegant: "/venue/b2.webp",
  chandelier: "/venue/bro04.webp",

  // Ceremony / weddings
  ceremony: "/venue/up_ceremony.webp",
  floralArch: "/venue/z12.jpg",

  // Florals & décor — signature red mixed with blush/white
  rosesBouquet: "/venue/up_florals.webp",
  bouquet: "/venue/g9.jpg",
  decorTable: "/venue/z11.jpg",
  decorCandles: "/venue/z09.jpg",
  decorHero: "/venue/z05.jpg",
  redArch: "/venue/z12.jpg",
  redCenterpiece: "/venue/z06.jpg",
  redHeadTable: "/venue/z03.webp",
  redPlace: "/venue/z02.webp",
  blushArch: "/venue/b3.jpg",
  blushCenterpiece: "/venue/g2.jpg",

  // Catering
  cateringSpread: "/venue/up_catering.webp",
  catering: "/venue/g10.jpg",

  // Location / entry (real venue shots — no stock)
  hotelExterior: "/venue/g1.jpg",
  arlington: "/venue/bro03.webp",

  // Brochure cover (real Vista brochure asset)
  brochureCover:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_wedding-inquiry-hub/artifacts/kj5d4ddu_V3_Vista%2BBanquet%2BHall%2BWedding%2BBrochure-640w.webp",
};

// Full gallery set — every real venue photograph, red & blush mixed throughout.
export const GALLERY_IMAGES = [
  { src: "/venue/z12.jpg", alt: "Dramatic red rose ceremony arch", cat: "Weddings" },
  { src: "/venue/b1.webp", alt: "Vista grand ballroom set for a wedding reception", cat: "Ballroom" },
  { src: "/venue/z05.jpg", alt: "Red rose centerpiece with candelabra", cat: "Décor" },
  { src: "/venue/bro02.webp", alt: "Ballroom styled with tall floral centerpieces", cat: "Ballroom" },
  { src: "/venue/up_florals.webp", alt: "Blush rose bouquet detail", cat: "Décor" },
  { src: "/venue/up_catering.webp", alt: "In-house catering presentation", cat: "Catering" },
  { src: "/venue/z03.webp", alt: "Red rose head table with red linens", cat: "Décor" },
  { src: "/venue/b3.jpg", alt: "Blush and white floral arch", cat: "Weddings" },
  { src: "/venue/z11.jpg", alt: "Red rose centerpieces on round tables", cat: "Décor" },
  { src: "/venue/g10.jpg", alt: "Buffet and chef stations", cat: "Catering" },
  { src: "/venue/up_ballroom.jpeg", alt: "Ballroom under crystal chandeliers", cat: "Ballroom" },
  { src: "/venue/z02.webp", alt: "Red napkin place setting with gold charger", cat: "Décor" },
  { src: "/venue/g11.jpg", alt: "Elegant floral arch backdrop", cat: "Weddings" },
  { src: "/venue/z06.jpg", alt: "Tall red rose centerpieces", cat: "Décor" },
  { src: "/venue/bro01.webp", alt: "Place setting detail with gold beaded charger", cat: "Décor" },
  { src: "/venue/z13.jpg", alt: "Red rose head table styling", cat: "Décor" },
  { src: "/venue/up_ceremony.webp", alt: "Ceremony aisle with white florals", cat: "Weddings" },
  { src: "/venue/z04.webp", alt: "Signature drinks styled with red roses", cat: "Catering" },
  { src: "/venue/g2.jpg", alt: "White floral centerpiece with blush napkins", cat: "Décor" },
  { src: "/venue/z10.jpg", alt: "Red floral head table", cat: "Décor" },
  { src: "/venue/b2.webp", alt: "Full hall view with gold chiavari chairs", cat: "Ballroom" },
  { src: "/venue/z14.jpg", alt: "Red roses with reserved place setting", cat: "Décor" },
  { src: "/venue/g5.jpg", alt: "White and green floral stage backdrop", cat: "Weddings" },
  { src: "/venue/z07.webp", alt: "Red rose reception styling", cat: "Décor" },
  { src: "/venue/g7.jpg", alt: "Reception hall with gold columns", cat: "Ballroom" },
  { src: "/venue/z09.jpg", alt: "Red roses in close detail", cat: "Décor" },
  { src: "/venue/g3.jpg", alt: "In-house catering buffet", cat: "Catering" },
  { src: "/venue/vis3.png", alt: "Red floral head table, full hall view", cat: "Décor" },
  { src: "/venue/bro03.webp", alt: "Ballroom set with tall centerpieces", cat: "Ballroom" },
  { src: "/venue/z01.jpg", alt: "Red rose centerpieces along the head table", cat: "Décor" },
  { src: "/venue/g8.jpg", alt: "White floral ceremony arch", cat: "Weddings" },
  { src: "/venue/z08.webp", alt: "Signature drinks with red rose accents", cat: "Catering" },
  { src: "/venue/g9.jpg", alt: "Tall blush and white centerpiece", cat: "Décor" },
  { src: "/venue/bro05.webp", alt: "Head table with lush florals", cat: "Décor" },
  { src: "/venue/g1.jpg", alt: "Welcome mirror at the entry", cat: "Venue" },
  { src: "/venue/b4.jpg", alt: "Round table with gold candle stands", cat: "Ballroom" },
  { src: "/venue/g12.jpg", alt: "Reception tables with gold columns", cat: "Ballroom" },
  { src: "/venue/bro04.webp", alt: "Ballroom with gold columns and chandeliers", cat: "Ballroom" },
  { src: "/venue/g4.jpg", alt: "Place settings with gold chargers", cat: "Décor" },
  { src: "/venue/g6.jpg", alt: "Table setting detail", cat: "Décor" },
];

export const CONTACT = {
  addressLine1: "7846 Richmond Highway",
  addressLine2: "Alexandria, VA 22306",
  phone: "(703) 332-9595",
  phoneHref: "tel:+17033329595",
  email: "info@vistabanquethall.com",
  mapUrl: "https://www.google.com/maps/place/Vista+Banquet+Hall+of+Alexandria/data=!4m2!3m1!1s0x0:0x82a3ea774d78e4b1?sa=X&ved=1t:2428&ictx=111",
  theKnot: "https://www.theknot.com/marketplace/vista-banquet-hall-alexandria-va-2088993",
  weddingWire: "https://www.weddingwire.com/biz/vista-banquet-hall/43865db769c09b40.html",
  instagram: "https://www.instagram.com/vistabanquet",
};

// GoHighLevel form IDs
export const GHL_FORMS = {
  pricing: { id: "ZBLAafXFynxRFZOD3J6k", name: "1.0 Optin form (PW Wed brochure24)", height: 809 },
  tour: { id: "k5AiB17yYzG0QotuT4EV", name: "2.0 Appointment Form", height: 587 },
  contact: { id: "07UQjvzwCkL1YjCeV1ei", name: "1.0 Optin form (PW Contact Us)", height: 809 },
};

// Northern Virginia locations served
export const LOCATIONS = [
  { name: "Alexandria", note: "Our home — minutes from Old Town along Richmond Highway." },
  { name: "Springfield", note: "A short drive south via I-95 & the Fairfax County Parkway." },
  { name: "Falls Church", note: "Just north through the heart of Fairfax County." },
  { name: "Arlington", note: "Moments from the Potomac, Reagan National & DC." },
];

// Getting here — airports & nearby hotels for out-of-town guests
export const AIRPORTS = [
  { code: "DCA", name: "Reagan National", time: "≈ 15 min drive" },
  { code: "IAD", name: "Washington Dulles Intl.", time: "≈ 35 min drive" },
  { code: "BWI", name: "Baltimore / Washington", time: "≈ 55 min drive" },
];

export const HOTELS = [
  { name: "Embassy Suites by Hilton", area: "Alexandria Old Town" },
  { name: "Kimpton Lorien Hotel & Spa", area: "Old Town Alexandria" },
  { name: "Hilton Alexandria Mark Center", area: "Alexandria" },
  { name: "Hampton Inn & Suites", area: "Alexandria Old Town South" },
];
